import { ShoppingBag } from "lucide-react";
import { Link } from "react-router-dom";
import { useCart } from "../lib/cart";
import InstallApp from "./InstallApp";

export default function TopBar({ onOpenCart }) {
  const { count } = useCart();

  return (
    <header className="mlobox-gradient sticky top-0 z-30 text-white shadow-md">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center gap-3">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-logo-link">
          <img src="/logo192.png" alt="MLOBOX logo" data-testid="brand-logo" className="h-10 w-10 rounded-xl shadow-md ring-2 ring-white/30" />
          <div className="font-display font-extrabold text-xl tracking-tight leading-none">MLOBOX</div>
        </Link>

        <div className="ml-auto flex items-center gap-2">
        <InstallApp />
        <button
          data-testid="cart-trigger-top"
          onClick={onOpenCart}
          className="relative bg-white/15 hover:bg-white/25 transition-colors rounded-full p-2"
        >
          <ShoppingBag size={20} />
          {count > 0 && (
            <span data-testid="cart-count-badge" className="absolute -top-1 -right-1 bg-white text-[#CC1A00] rounded-full text-[11px] font-bold h-5 min-w-5 px-1 grid place-items-center shadow">
              {count}
            </span>
          )}
        </button>
        </div>
      </div>
    </header>
  );
}
